<template>
  <div class="flex flex-col items-center py-4">
    <div>
      <RadioGroup v-model="selectedIntervalValue">
        <Radio
          v-for="(pauseInterval, index) in pauseIntervals"
          :key="index"
          :value="pauseInterval.intervalValue"
          class="pb-4"
        >
        <span class="inline-flex items-center gap-1">
          {{ pauseInterval.intervalValue }}
          <CommonLabel
            :path="`BWF/shop/account/subscriptions/contract/${getIntervalUnit(pauseInterval)}`"
          />
        </span>
        </Radio>
      </RadioGroup>
    </div>
    <div class="font-bold">
      <CommonLabel path="BWF/shop/account/subscriptions/contract/nextDeliveryLabel" />:
      <FormattedDate
        v-if="activeIntervalOption?.nextExecutionDate"
        :date="activeIntervalOption?.nextExecutionDate"
        pattern="DD.MM.YY"
      />
    </div>
  </div>
</template>

<script setup>
import { Radio } from "~/components/clarity-ui/Radio/";
import { RadioGroup } from "~/components/clarity-ui/Radio/RadioGroup";
import FormattedDate from "~/templates/elements/FormattedDate.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { getLabels } = useCommonLabels();

const props = defineProps(["pauseIntervals", "modelValue"]);

const selectedIntervalValue = defineModel("modelValue");

const activeIntervalOption = computed(() => {
  return props.pauseIntervals?.find(
    (interval) => interval.intervalValue === selectedIntervalValue.value,
  );
});

const getIntervalUnit = (interval) => {
  /*
  Shopware intervalUnits are always in plural (days, weeks, months and years)
  to map the CommonLabel for single versions we have to slice the last letter ('s')
  to get day, week, month and year
  */

  const unit = interval.intervalUnit;
  const value = interval.intervalValue;

  if (value === 1) {
    return unit.slice(0, -1); //months -> month
  } else {
    return unit; //months
  }
};
</script>
